import React, { useContext, useEffect } from "react";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "../..";
import PagePreview from "./Preview";
import { getData } from "~/functions/gridFunctions";

const defaultGridHeader = [
  {
    title: "Name",
    name: "name",
    type: "text",
    filter: true,
  },
  {
    title: "Code",
    name: "code",
    type: "text",
    filter: true,
  },
  {
    title: "Balance Effect",
    name: "affects_balance",
    type: "text",
    filter: true,
  },
  {
    title: "Active",
    name: "is_active",
    type: "boolean",
    filter: false,
  },
];

export default function EmployeeMovement() {
  const defaultOrderBy = { column: "name", asc: true };
  const {
    accessModule,
    setActiveFilters,
    limit,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLoadingData,
    setPages,
    orderBy,
    search,
    page,
    opened,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "hr-employee-movement"
  );

  useEffect(() => {
    setActiveFilters([]);
  }, [setActiveFilters]);

  useEffect(() => {
    setGridHeader(defaultGridHeader);
  }, [setGridHeader]);

  async function loader() {
    setLoadingData(true);
    const data = await getData("employeemovements", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });

    if (!data) {
      setGridData([]);
      setLoadingData(false);
      return;
    }

    const gridDataValues = data.map(
      ({ id, name, code, affects_balance, is_active, canceled_at }, index) => ({
        show: true,
        id,
        fields: [name, code, affects_balance, Boolean(is_active)],
        selectable: !canceled_at && is_active,
        canceled: canceled_at || !is_active,
        page: Math.ceil((index + 1) / limit),
      })
    );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
